import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import Column from '../Pdf/components/Column';
import theme from '../Pdf/components/theme';
import { jsonToPDF } from '../Pdf/jsonToPDF';
import { BlockNoteDocument } from '../BlockNoteEditor/schema';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import SectionTitle from './components/pdf/SectionTitle';
import { PeriodEndReportSectionPageProps } from './types';

const styles = StyleSheet.create({
  body: {
    padding: theme.spacing(
      theme.spacingSizes.md,
      theme.spacingSizes.lg,
      0,
      theme.spacingSizes.lg,
    ),
  },
});

type Props = PeriodEndReportSectionPageProps & {
  commentary: BlockNoteDocument;
};

const FundManagerCommentary: FC<Props> = ({
  sectionNumber,
  commentary,
  ...rest
}) => {
  return (
    <PeriodEndReportPage {...rest}>
      <SectionTitle
        sectionNumber={sectionNumber}
        title="Fund manager commentary"
      />
      <Column spacing="sm" style={styles.body}>
        {jsonToPDF({ document: commentary })}
      </Column>
    </PeriodEndReportPage>
  );
};

export default FundManagerCommentary;
